import { render, staticRenderFns } from "./CustomFieldEditorModalDialog.vue?vue&type=template&id=4460b7da"
import script from "./CustomFieldEditorModalDialog.vue?vue&type=script&lang=js"
export * from "./CustomFieldEditorModalDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports